import React, { Component } from 'react';
import { get } from 'lodash/fp';
import PropTypes from 'prop-types';
import { Content, Loader, Message } from 'rsuite';
import {
  ItemType,
  PackageType,
  InventoryTypesLabel
} from '../../../../constants/inventory/InventoryTypes';
import {
  InventoryItemType,
  InventoryPackageType,
  InventoryItemSkuType,
  InventoryAvailabilityType
} from '../../../../interfaces/inventory';
import InventoryActions from '../../../../constants/inventory/InventoryActions';
import {
  inventoryItemsPath,
  inventoryViewItemPath,
  inventoryPackagesPath,
  inventoryViewPackagePath
} from '../../../Paths';
import * as PERMISSIONS from '../../../../constants/permissions/inventory';
import { modifyAccess } from '../../../../helpers/permission';
import AccessControl from '../../../../components/AccessControl';
import AccessDenied from '../../../../components/AccessDenied';
import Breadcrumb from '../../../../components/Breadcrumb';
import InventoryAdjustItemForm from '../../../../containers/inventory/AdjustItemForm';
import InventoryAdjustPackageForm from '../../../../containers/inventory/AdjustPackageForm';
import InventoryPageLayout from '../../../../containers/inventory/PageLayout';
import PageHeader from '../../../../components/PageHeader';

const LabelByAction = {
  [InventoryActions.ADD]: 'Add Quantity',
  [InventoryActions.REMOVE]: 'Reduce Quantity',
  [InventoryActions.MOVE]: 'Move'
};

const pathsByType = {
  [ItemType]: {
    list: inventoryItemsPath,
    view: inventoryViewItemPath
  },
  [PackageType]: {
    list: inventoryPackagesPath,
    view: inventoryViewPackagePath
  }
};
const permissionByType = {
  [ItemType]: PERMISSIONS.ITEM,
  [PackageType]: PERMISSIONS.PACKAGE
};

export default class AdjustInventoryItem extends Component {
  static propTypes = {
    action: PropTypes.number.isRequired,
    locationId: PropTypes.number,
    zoneId: PropTypes.number,
    item: PropTypes.oneOfType([InventoryItemType, InventoryPackageType]),
    type: PropTypes.oneOf([ItemType, PackageType]).isRequired,
    skus: PropTypes.arrayOf(InventoryItemSkuType),
    packageItems: PropTypes.arrayOf(PropTypes.shape({})),
    availability: PropTypes.arrayOf(InventoryAvailabilityType),
    isFetchingItem: PropTypes.bool.isRequired,
    isFetchingSkus: PropTypes.bool,
    isFetchingPackageItems: PropTypes.bool,
    isFetchingItemAvailability: PropTypes.bool,
    onInit: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
  };

  static defaultProps = {
    item: null,
    locationId: null,
    zoneId: null,
    skus: [],
    packageItems: [],
    availability: [],
    isFetchingSkus: false,
    isFetchingPackageItems: false,
    isFetchingItemAvailability: false
  };

  constructor(props) {
    super(props);
    this.state = { isInit: false };
  }

  componentDidMount() {
    const { isInit } = this.state;
    const { onInit } = this.props;
    if (!isInit) {
      onInit();
      this.setState({ isInit: true });
    }
  }

  get isPackage() {
    const { type } = this.props;
    return type === PackageType;
  }

  renderBreadcrumb() {
    const { item, action, type } = this.props;
    const paths = get(type, pathsByType);
    return (
      <Breadcrumb
        items={[
          {
            path: paths.list,
            label: `${InventoryTypesLabel[type]}s`
          },
          {
            path: paths.view.replace(':id', item.id),
            label: item.name
          },
          { label: LabelByAction[action] }
        ]}
      />
    );
  }

  renderAdjustForm() {
    const {
      item,
      skus,
      availability,
      packageItems,
      action,
      locationId,
      zoneId,
      onSubmit
    } = this.props;

    if (this.isPackage && action !== InventoryActions.REMOVE) {
      return (
        <Message showIcon type="error" title="Unsupported action for package" />
      );
    }

    return this.isPackage ? (
      <InventoryAdjustPackageForm
        item={item}
        locationId={locationId}
        skus={skus}
        action={action}
        packageItems={packageItems}
        availability={availability}
        onSubmit={onSubmit}
      />
    ) : (
      <InventoryAdjustItemForm
        item={item}
        skus={skus}
        action={action}
        zoneId={zoneId}
        availability={availability}
        onSubmit={onSubmit}
      />
    );
  }

  render() {
    const {
      action,
      type,
      item,
      isFetchingItem,
      isFetchingSkus,
      isFetchingPackageItems,
      isFetchingItemAvailability
    } = this.props;

    const isLoading =
      isFetchingItem ||
      isFetchingSkus ||
      isFetchingPackageItems ||
      isFetchingItemAvailability;

    return (
      <InventoryPageLayout>
        <AccessControl
          allowOnlyFor={modifyAccess(permissionByType[type])}
          fallback={<AccessDenied />}
        >
          {item && this.renderBreadcrumb()}
          <PageHeader
            title={`${InventoryTypesLabel[type]}  ${LabelByAction[action]}`}
          />
          <Content>
            {!isLoading && item ? (
              this.renderAdjustForm()
            ) : (
              <Loader backdrop content="loading..." vertical />
            )}
          </Content>
        </AccessControl>
      </InventoryPageLayout>
    );
  }
}
